export const ENV_APP_PROJECT: 'radionet-portal' | 'my-monitoring' = process.env.REACT_APP_PROJECT as 'radionet-portal' | 'my-monitoring'
